<template lang="html">
  <div class="wrapper fadeInDown">
    <div class="fadeIn first">
      <img src="@/assets/gw-standard-white.png" class="login-logo">
    </div>
    <div id="formContent">
      <h4>{{$t('settings.newPassword')}}</h4>
     <form @submit="onSubmit($event)">
       <GwPassword v-model="password" g-class="login-input" />
       <button class="btn btn-success mt-3" :disabled="loading || !passwordIsValid">
         <span
           class="spinner-border spinner-border-sm"
           v-show="loading"
         />
         {{$t('button.send')}}
       </button>
     </form>
    </div>
  </div>
</template>

<script>
import GwPassword from '@/components/gwPassword/GwPassword.vue';
import { recoverPassword } from '@/api/index';

export default {
  name: 'Forgot',
  components: {
    GwPassword,
  },
  data() {
    return {
      password: '',
      loading: false,
    };
  },
  computed:{
    passwordIsValid (){
      
        const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9])(?=.*[0-9]).{8,}$/;    
        return regex.test(this.password);
      
  },
},
  methods: {
    onSubmit(e) {
      e.preventDefault();
      this.loading = true;
      recoverPassword(this.$router.currentRoute.params.token, this.password).then((res) => {
        this.loading = false;
        console.warn(res);
        this.$router.push('/login');
      })
        .catch(() => {
          this.loading = false;
        });
    },

  },
};
</script>

<style lang="scss" scoped>
@import './login.scss';
</style>
